import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _ImpOfficeNew, _OfficeNew } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { CitiesEditor } from "../../../../Inventories-Warehouses/Product/Countries/Cities/CitiesEditor";
import { CompanyEditor } from "../../../../erp/cellEditor/Company/CompanyEditor";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { MarketPlaceEditor } from "../../../../Inventories-Warehouses/Product/MarketPlace/MarketPlaceEditor";
import { AirportEditor } from "../../../../Inventories-Warehouses/Product/Airport/AirportEditor";
import { FileInput } from "../../../../theme/Component/FileInput";
import { OfficeRole } from "./OfficeRole/OfficeRole";
import { CashDeskAccountOffice } from "./CashDeskAccountOffice/CashDeskAccountOffice";
import { OfficeUse } from "./OfficeRole/OfficeUser/OfficeUser";



export const OfficeNew = () => {

    const office = useDataBean(_OfficeNew);
    const impoffice = useDataBean(_ImpOfficeNew);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modaluser, setModaluser] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRole, setModalRole] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCajas, setModalCajas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        office.instance.getOfficeCatalogbypaginator(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        office.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        office.instance.deleteOffice(office.bean.IDOffice).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        office.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDOffice', visible: true },
        { title: 'Código Oficina', property: 'Code', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Ubicación Geográfica', property: 'SiteIDName', visible: true },
        { title: 'Empresa', property: 'CompanyName', visible: true },
        { title: 'Tercerizada', property: 'Outsourced', visible: true },
        { title: 'Tercero', property: 'Nit', visible: true },
        { title: 'MarketPlace', property: 'MarketPlaceName', visible: true },
        { title: 'Teléfono (1)', property: 'Tel1', visible: true },
        { title: 'Teléfono (2)', property: 'Tel2', visible: true },
        { title: 'Teléfono (3)', property: 'Tel3', visible: true },
        { title: 'Fax', property: 'Fax', visible: true },
        { title: 'Número Celular (1)', property: 'CellNumber1', visible: true },
        { title: 'Número Celular (2)', property: 'CellNumber2', visible: true },
        { title: 'Dirección', property: 'Address', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'URL Sitio Web', property: 'WebSiteUrl', visible: true },
        { title: 'Aeropuerto', property: 'AirportName', visible: true },
        { title: 'Lector de Barras', property: 'BarCodeReader', visible: true },
        { title: 'Impresora de Etiquetas', property: 'StickerPrinter', visible: true },
        { title: 'Impresión de Guías de Transporte', property: 'GuidePrinter', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Roles de la Oficina', icono: 'ri-folder-settings-line', visible: single.canEdit(), evento: () => { setModalRole({ ...modalRole, "view": true }) } },
            { titulo: 'Empleados de la Oficina', icono: 'ri-file-user-line', visible: single.canEdit(), evento: () => { setModaluser({ ...modaluser, "view": true }) } },
            { titulo: 'Cajas/POS de la Oficina', icono: 'ri-edit-box-fill', visible: single.canEdit(), evento: () => { setModalCajas({ ...modalCajas, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const verimport = () => {
        setModalimp({ ...modalimp, "view": true });
    }
    const importOfficeCatalog = () => {

        impoffice.instance.importOfficeCatalog(impoffice.bean.Media, impoffice.bean.MediaContext, null).then(
            (resp: any) => {
                // console.log(resp);
                getLista();
                setModalimp({ ...modalimp, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    return (
        <BasicPage titulo="Oficinas">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-6">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={verimport}>
                        Importar Oficinas
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={office.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Código Oficina</label>
                                <input type="text" name="Code" className="form-control" value={office.bean.Code} onChange={(e) => { office.setBean({ ...office.bean, "Code": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={office.bean.Name} onChange={(e) => { office.setBean({ ...office.bean, "Name": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <CitiesEditor render={office.bean.SiteIDName} idSelector={office.bean.IDCities} onChange={(e) => { office.setBean({ ...office.bean, "IDCities": e.IDCities, "SiteIDName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <CompanyEditor id={office.bean.IDCompany} onchange={(e) => { office.setBean({ ...office.bean, "IDCompany": e }) }} />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Tercerizada" estado={office.bean.Outsourced} eventChange={(e: any) => { office.setBean({ ...office.bean, "Outsourced": e }) }}></BasicSwitch>
                            </div>
                            {office.bean.Outsourced && <>
                                <div className="col-md-6">
                                    <AccountEditor idAccount={office.bean.IDAccount} label="Tercero" onChange={(e: any) => { office.setBean({ ...office.bean, "IDAccount": e.IDAccount }) }} />
                                </div>
                            </>}
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitada" estado={office.bean.Enabled} eventChange={(e: any) => { office.setBean({ ...office.bean, "Enabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <MarketPlaceEditor idSelector={office.bean.IDMarketPlace} onChange={(e: any) => { office.setBean({ ...office.bean, "IDMarketPlace": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Teléfono (1)</label>
                                <input type="text" name="Tel1" className="form-control" value={office.bean.Tel1} onChange={(e) => { office.setBean({ ...office.bean, "Tel1": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Teléfono (2)</label>
                                <input type="text" name="Tel2" className="form-control" value={office.bean.Tel2} onChange={(e) => { office.setBean({ ...office.bean, "Tel2": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Teléfono (3)</label>
                                <input type="text" name="Tel3" className="form-control" value={office.bean.Tel3} onChange={(e) => { office.setBean({ ...office.bean, "Tel3": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fax</label>
                                <input type="text" name="Fax" className="form-control" value={office.bean.Fax} onChange={(e) => { office.setBean({ ...office.bean, "Fax": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Número Celular (1)</label>
                                <input type="text" name="CellNumber1" className="form-control" value={office.bean.CellNumber1} onChange={(e) => { office.setBean({ ...office.bean, "CellNumber1": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Número Celular (2)</label>
                                <input type="text" name="CellNumber2" className="form-control" value={office.bean.CellNumber2} onChange={(e) => { office.setBean({ ...office.bean, "CellNumber2": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Dirección</label>
                                <input type="text" name="Address" className="form-control" value={office.bean.Address} onChange={(e) => { office.setBean({ ...office.bean, "Address": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Correo Electrónico</label>
                                <input type="text" name="eMail" className="form-control" value={office.bean.eMail} onChange={(e) => { office.setBean({ ...office.bean, "eMail": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>URL Sitio Web</label>
                                <input type="text" name="WebSiteUrl" className="form-control" value={office.bean.WebSiteUrl} onChange={(e) => { office.setBean({ ...office.bean, "WebSiteUrl": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <AirportEditor render={office.bean.AirportName} idSelector={office.bean.IDAirport} onChange={(e) => { office.setBean({ ...office.bean, "IDAirport": e.IDAirport, "AirportName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Lector de Barras" estado={office.bean.BarCodeReader} eventChange={(e: any) => { office.setBean({ ...office.bean, "BarCodeReader": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Impresora de Etiquetas" estado={office.bean.StickerPrinter} eventChange={(e: any) => { office.setBean({ ...office.bean, "StickerPrinter": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Impresión de Guías de Transporte" estado={office.bean.GuidePrinter} eventChange={(e: any) => { office.setBean({ ...office.bean, "GuidePrinter": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={office.bean.Description} onChange={(e) => { office.setBean({ ...office.bean, "Description": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalimp} updateModal={setModalimp} eventModal={importOfficeCatalog}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    Media={impoffice.bean.Media}
                                    MediaContext={impoffice.bean.MediaContext}
                                    directory='Agency'
                                    label='Archivo'
                                    docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                    onCreate={(Filemap: any) => { impoffice.setBean({ ...impoffice.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalRole} updateModal={setModalRole} >
                        <div className="row">
                            <OfficeRole idOffice={office.bean.IDOffice} />
                        </div>
                    </Modal>
                    <Modal modal={modalCajas} updateModal={setModalCajas} >
                        <div className="row">
                            <CashDeskAccountOffice idOffice={office.bean.IDOffice} />
                        </div>
                    </Modal>
                    <Modal modal={modaluser} updateModal={setModaluser} >
                        <div className="row">
                            <OfficeUse idOffice={office.bean.IDOffice} />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {office.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}